import React, {FC} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryPayback} from "@/service/payback.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {TitleBar} from "@/widget/TitleBar/TitleBar";
import {checkQueryKey, formatTime, getRealId, getSellerNames} from "@/helper/method";
import {ContractDetail} from "@/widget/CommonDetail/ContractDetail";
import {ModeType, useDialogModal, useDrawerModal} from "@/store/global.c";

interface ViewPaybackProps {
    flag: number;
    mode: ModeType;
}

export const ViewPayback: FC<ViewPaybackProps> = ({flag, mode}) => {
    const {id: drawerId} = useDrawerModal()
    const {id: dialogId} = useDialogModal()
    const id: number = getRealId(mode, drawerId, dialogId);
    const {data: paybackData, isLoading: paybackLoading} = useQueryPayback({id}, checkQueryKey(id))
    const payback = paybackData?.data

    return <> <ResultWrapper isLoading={paybackLoading} isEmpty={isEmpty(payback)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'客户名称'} content={payback?.customerName}/>
                <GridItem title={'业务内容'} content={payback?.productName}/>
                <GridItem title={'业务人员'} content={getSellerNames(payback?.creator, payback?.seller)}/>
                <GridItem title={`${flag == -1 ? '预计' : ''}回款金额`} content={payback?.paymentMoney}/>
                <GridItem title={`${flag == -1 ? '预计' : ''}回款时间`} content={formatTime('D', payback?.paymentDate)}/>
                <GridItem title={'到账方式'} content={payback?.paymentMethod}/>
                <GridItem title={'更新时间'} content={formatTime('D', payback?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime('D', payback?.createdAt)}/>
                <GridItem minHeight={'48px'} size={12} title={'备注'} content={payback?.remark || '-'}/>
            </Grid>
            {!isEmpty(payback?.contract) && <>
                <TitleBar title={"合同信息"}/>
                <ContractDetail showProduct={true} data={payback?.contract}/></>}
        </Stack></ResultWrapper>
    </>
}